import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import { URL, LABEL, ATHENA_DASHBOARD_RESOURCES, IMAGE_SOURCE } from './helper';
import useAthenaCrudDashboardHome from './useAthenaDashboardHome';
import useAthenaCrudDashboardHomeCss from './useAthenaDashboardHomeCss';

const AthenaDashboardHome: React.FC<{}> = () => {
	const history = useHistory();
	const { isEnabled } = useAthenaCrudDashboardHome();
	const { keyHeading, subKeyHeading, cardCSS } = useAthenaCrudDashboardHomeCss();
	return (
		<div className={keyHeading}>
			{_map(_keys(ATHENA_DASHBOARD_RESOURCES), (subEntity: string) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={subKeyHeading}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default AthenaDashboardHome;
